// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogContent_dialogContent__6j1JA","btnArea":"DialogContent_btnArea__3D-Qk"};